exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.equiinfo .el-table td {\n  width: 300px;\n}\n.el-table th {\n  text-align: center;\n}\n.el-table td {\n  text-align: center;\n}\n", ""]);

// exports
